<script lang="ts">
  import { onMount } from "svelte";
  import GameInterface from "./GameInterface.svelte";
  import LobbySettings from "./LobbySettings.svelte";
  import PostEntryModals from "./PostEntryModals.svelte";
  import "../styles/game.css";

  function loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const existing = document.querySelector<HTMLScriptElement>(`script[data-bhc-runtime="${src}"]`);
      if (existing) {
        resolve();
        return;
      }
      const script = document.createElement("script");
      script.src = src;
      script.dataset.bhcRuntime = src;
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`failed to load ${src}`));
      document.head.append(script);
    });
  }

  onMount(async () => {
    await loadScript(`/bhc.config.js?v=${Date.now()}`);
    await import("../game/runtime");
  });
</script>

<svelte:head>
  <title>Beast Hunter: Chronicles of Gaea | 무료 웹 MMORPG</title>
  <meta
    name="description"
    content="Beast Hunter: Chronicles of Gaea는 브라우저에서 바로 접속해 Google 로그인으로 함께 사냥, 제작, 장비 성장을 즐기는 무료 웹 MMORPG입니다."
  />
  <meta name="theme-color" content="#020305" />
  <meta name="color-scheme" content="dark" />
  <link rel="manifest" href="/site.webmanifest" />
  <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
</svelte:head>

<div class="game-root relative h-screen w-screen">
  <LobbySettings />
  <GameInterface />
  <PostEntryModals />
</div>
